import {createAction, handleActions} from 'redux-actions';
import {Map, List, fromJS/*, setIn*/} from 'immutable';
import {pender} from 'redux-pender';
import * as api from 'lib/api';
// import isEmptyObject from 'is-empty-object';
// import { EX_ITEM_LIST01 } from "../../util/constants";
import { getLocalStorageList } from "../../util/localStorage";

const SET_ITEMS_FILTER = 'items/SET_ITEMS_FILTER';
const SET_ITEMS_FILTER_DTL = 'items/SET_ITEMS_FILTER_DTL';
const GET_ITEM_LIST = 'items/GET_ITEM_LIST';
const SET_ITEMS_SORT = 'items/SET_ITEMS_SORT';
const SET_ITEMS_FILTER_TEXT = 'items/SET_ITEMS_FILTER_TEXT';
const SET_FILTER_INIT = 'items/SET_FILTER_INIT';
const CTRL_ITEM_DTL_POPUP = 'items/CTRL_ITEM_DTL_POPUP';
const SET_ITEM_DETAIL_OPTION = 'items/SET_ITEM_DETAIL_OPTION';
const SET_BODY_UP = 'items/SET_BODY_UP';
const SET_POWER_UP = 'items/SET_POWER_UP';
const SET_PREFIX_UP = 'items/SET_PREFIX_UP';
const GET_ITEM_VIEW = 'items/GET_ITEM_VIEW';
const SET_LOCAL_HIST = 'items/SET_LOCAL_HIST';
const SET_LAYER_OPEN_YN = 'items/SET_LAYER_OPEN_YN';

const RECENT_KEY = "recentItems";

export const setItemsFilter = createAction(SET_ITEMS_FILTER);
export const setItemsFilterDtl = createAction(SET_ITEMS_FILTER_DTL);
export const getItemList = createAction(GET_ITEM_LIST, api.getItemList);
// export const getItemList = createAction(GET_ITEM_LIST);
export const setItemsSort = createAction(SET_ITEMS_SORT);
export const setItemsFilterText = createAction(SET_ITEMS_FILTER_TEXT);
export const setFilterInit = createAction(SET_FILTER_INIT);
export const ctrlItemDtlPopup = createAction(CTRL_ITEM_DTL_POPUP);
export const setItemDetailOption = createAction(SET_ITEM_DETAIL_OPTION);
export const setBodyup = createAction(SET_BODY_UP);
export const setPowerup = createAction(SET_POWER_UP);
export const setPrefixUp = createAction(SET_PREFIX_UP);
export const getItemView = createAction(GET_ITEM_VIEW, api.getItemView);
export const setLocalHist = createAction(SET_LOCAL_HIST);
export const setLayerOpenYn = createAction(SET_LAYER_OPEN_YN);

const initialState = Map({
  itemFilters: Map({
    itemKind: '01',
    clyn: List(),
    illegal: List(),
    tier: List(),
    itemDtlDv01: List(), //원거리종류
    itemDtlDv02: List(), //근거리종류
    itemDtlDv03: List(), //방어구
    itemDtlDv04: List(), //악세
    itemDtlDv05: List(), //코튬날개
    itemDtlDv06: List(), //미사용
    itemKindMap: {
      itemKind01: {name: '원거리무기'},
      itemKind02: {name: '근거리무기'},
      itemKind03: {name: '방패'},
      itemKind04: {name: '방어구'},
      itemKind05: {name: '악세서리'},
      itemKind06: {name: '코스튬날개'}
    },
    sortKind: '0',
    filterText: ''
  }),
  itemListFiltering: Map({
    list01: List(), //원거리
    list02: List(), //근거리
    list03: List(), //방패 
    list04: List(), //방어구
    list05: List(), //악세
    list06: List() //코튬날개
  }),
  itemList: Map({
    list01: List(), //원거리
    list02: List(), //근거리
    list03: List(), //방패 
    list04: List(), //방어구
    list05: List(), //악세
    list06: List() //코튬날개
  }),
  itemLayerPopInfo: Map({
    isView: 'none',
    // lstItemList : List(EX_ITEM_LIST01.slice(0,2).map((obj)=>({'ITEM_SEQ':obj.ITEM_SEQ,'ITEM_NM':obj.ITEM_NM,'IMG_SRC':obj.IMG_SRC})))
    lstItemList : List(),
    openYn : 'Y'
  }),
  currSelWeapon: Map({
    currItem: Map(),
    currItemPoweredBy: List(),
    currItemOption: {
      bodyUp: 0,
      powerUp: 0,
      optionView: ''
    }
  }),
  plusUpGrid: List(),
  currSelArmmor: Map({
    currItem: Map(),
    currItemDefensedBy: List(),
    currItemOption: {
      bodyUp: 0,
      powerUp: 0,
      prefixUp: -1,
      optionView: ''
    }
  }),
  currSelAcCt: Map({
    currItem: Map(),
    currItemOption: {
      powerUp: 0,
      optionView: ''
    }
  })
});

export default handleActions({
  [SET_ITEMS_FILTER]: (state, action) => {
    const {value} = action.payload;
    const filterCurItemList = getItemFiltering('filterKind', state, value);
    
    return state.setIn(['itemFilters', 'itemKind'], value)
                .setIn(['itemListFiltering','list'+value], fromJS(filterCurItemList))
                .setIn(['itemFilters', 'filterText'], '');
  },
  [SET_ITEMS_FILTER_DTL]: (state, action) => {
    const {alt, name, /*value,*/ checked} = action.payload;
    let clyn = state.getIn(['itemFilters', 'clyn']).toJS();
    let illegal = state.getIn(['itemFilters', 'illegal']).toJS();
    let tier = state.getIn(['itemFilters', 'tier']).toJS();
    let itemDtlDv01 = state.getIn(['itemFilters', 'itemDtlDv01']).toJS();
    let itemDtlDv02 = state.getIn(['itemFilters', 'itemDtlDv02']).toJS();
    let itemDtlDv03 = state.getIn(['itemFilters', 'itemDtlDv03']).toJS();
    let itemDtlDv04 = state.getIn(['itemFilters', 'itemDtlDv04']).toJS();
    let itemDtlDv05 = state.getIn(['itemFilters', 'itemDtlDv05']).toJS();
    const itemKind = state.getIn(['itemFilters', 'itemKind']);
    
    if(checked) {
      if(alt.indexOf('CL') > -1) {
        clyn.push(name);
      }else if(alt.indexOf('합법') > -1 || alt.indexOf('불법') > -1) {
        illegal.push(name);
      }else if(alt === '등급') {
        tier.push(String(name));
      }else if(alt === '원거리무기종류') {
        itemDtlDv01.push(name);
      }else if(alt === '근거리무기종류') {
        itemDtlDv02.push(name);
      }else if(alt === '방어구종류') {
        itemDtlDv03.push(name);
        if(name === '여성코트') itemDtlDv03.push('여성자켓상의');
        if(name === '남성코트') itemDtlDv03.push('남성자켓상의');
      }else if(alt === '악세서리종류') {
        itemDtlDv04.push(name);
      }else if(alt === '코튬날개종류') {
        itemDtlDv05.push(name);
      }
    }else{
      if(alt.indexOf('CL') > -1) {
        clyn = clyn.filter((val) => name !== val);
      }else if(alt.indexOf('합법') > -1 || alt.indexOf('불법') > -1) {
        illegal = illegal.filter((val) => name !== val);
      }else if(alt === '등급') {
        tier = tier.filter((val) => name !== val);
      }else if(alt === '원거리무기종류') {
        itemDtlDv01 = itemDtlDv01.filter((val) => name !== val);
      }else if(alt === '근거리무기종류') {
        itemDtlDv02 = itemDtlDv02.filter((val) => name !== val);
      }else if(alt === '방어구종류') {
        itemDtlDv03 = itemDtlDv03.filter((val) => name !== val);
        if(name === '여성코트') itemDtlDv03 = itemDtlDv03.filter((val) => '여성자켓상의' !== val);
        if(name === '남성코트') itemDtlDv03 = itemDtlDv03.filter((val) => '남성자켓상의' !== val);
      }else if(alt === '악세서리종류') {
        itemDtlDv04 = itemDtlDv04.filter((val) => name !== val);
      }else if(alt === '코튬날개종류') {
        itemDtlDv05 = itemDtlDv05.filter((val) => name !== val);
      }
    }

    const filterCurItemList = getItemFiltering('filterDtl', state, itemKind, null, clyn, illegal, tier, itemDtlDv01, itemDtlDv02, itemDtlDv03, itemDtlDv04, itemDtlDv05);

    return state.setIn(['itemFilters', 'clyn'], fromJS(clyn))
                .setIn(['itemFilters', 'illegal'], fromJS(illegal))
                .setIn(['itemFilters', 'tier'], fromJS(tier))
                .setIn(['itemFilters', 'itemDtlDv01'], fromJS(itemDtlDv01))
                .setIn(['itemFilters', 'itemDtlDv02'], fromJS(itemDtlDv02))
                .setIn(['itemFilters', 'itemDtlDv03'], fromJS(itemDtlDv03))
                .setIn(['itemFilters', 'itemDtlDv04'], fromJS(itemDtlDv04))
                .setIn(['itemFilters', 'itemDtlDv05'], fromJS(itemDtlDv05))
                .setIn(['itemListFiltering','list'+itemKind], fromJS(filterCurItemList))
                ;
  },
  ...pender({
    type: GET_ITEM_LIST,
    onSuccess: (state, action) => {
      const id = state.getIn(['itemFilters', 'itemKind']);
      const {data: items} = action.payload;

      const filterCurItemList = getItemFiltering('itemInq', state, id, items);
      
      return state.setIn(['itemList','list'+id], fromJS(items))
                  .setIn(['itemListFiltering','list'+id], fromJS(filterCurItemList))
                  ;
    }
  }),
  // [GET_ITEM_LIST]: (state, action) => {
  //   const id = state.getIn(['itemFilters', 'itemKind']);
  //     // const {data: items} = action.payload;
  //     const items = items1;

  //     const filterCurItemList = getItemFiltering('itemInq', state, id, items);
  //     // console.log(filterCurItemList)
  //     return state.setIn(['itemList','list'+id], fromJS(items))
  //                 .setIn(['itemListFiltering','list'+id], fromJS(filterCurItemList))
  //                 ;
  // },
  ...pender({
    type: GET_ITEM_VIEW,
    onSuccess: (state, action) => {
      const {data: items} = action.payload;

      const id = getItemKind(items);

      return state.setIn(['itemFilters', 'itemKind'], id)
                  .setIn(['itemList','list'+id], fromJS(items));
    }
  }),
  [SET_ITEMS_SORT]: (state, action) => {
    const {value} = action.payload;
    
    return state.setIn(['itemFilters', 'sortKind'], value);
  },
  [SET_ITEMS_FILTER_TEXT]: (state, action) => {
    const {value} = action.payload;
    
    return state.setIn(['itemFilters', 'filterText'], value);
  },
  [SET_FILTER_INIT]: (state, action) => {
    const itemKind = state.getIn(['itemFilters', 'itemKind']);
    const itemList = state.getIn(['itemList', 'list'+itemKind]);
    
    return state.setIn(['itemFilters', 'clyn'], new List())
          .setIn(['itemFilters', 'illegal'], new List())
          .setIn(['itemFilters', 'tier'], new List())
          .setIn(['itemFilters', 'itemDtlDv01'], new List())
          .setIn(['itemFilters', 'itemDtlDv02'], new List())
          .setIn(['itemFilters', 'itemDtlDv03'], new List())
          .setIn(['itemFilters', 'itemDtlDv04'], new List())
          .setIn(['itemFilters', 'itemDtlDv05'], new List())
          .setIn(['itemFilters', 'itemDtlDv06'], new List())
          .setIn(['itemFilters', 'filterText'], '')
          .setIn(['itemListFiltering','list'+itemKind], itemList);
          ;
  },
  [CTRL_ITEM_DTL_POPUP]: (state, action) => {
    const {isView, itemSeq, selSkillSeq} = action.payload;
    // const itemKind = state.getIn(['itemFilters', 'itemKind']);
    let currItem = state.getIn(['currSelWeapon', 'currItem']).toJS();
    let plusUpGrid = state.getIn(['plusUpGrid']).toJS();
    
    if(itemSeq !== "") {
      // currItem = state.getIn(['itemList', 'list'+itemKind]).toJS().filter(
      //   (item) => item.ITEM_SEQ === itemSeq
      // )[0];
      currItem = state.get('itemList')
      .valueSeq()
      .flatMap(list => list)
      .find(item=> item.get('ITEM_SEQ') === itemSeq)
      .toJS();
    }

    const id = getItemKind(currItem);

    if(plusUpGrid.length === 0) {
      plusUpGrid = calcPlusUpGrid();
    }

    //로컬스토리지 저장추가. RECENT_KEY
    let list = getLocalStorageList(RECENT_KEY);

    list = list.filter(item => item.ITEM_SEQ !== itemSeq);
    // 맨 앞에 추가
    
    if(currItem !== null && currItem !== undefined) list.unshift(currItem);

    list = list.slice(0, 5);
    localStorage.setItem(RECENT_KEY, JSON.stringify(list));

    return state.setIn(['itemLayerPopInfo', 'isView'], isView)
                .setIn(['itemLayerPopInfo', 'selItemSeq'], itemSeq)
                .setIn(['currSelWeapon', 'currItem'], fromJS(currItem))
                .setIn(['currSelArmmor', 'currItem'], fromJS(currItem))
                .setIn(['currSelAcCt', 'currItem'], fromJS(currItem))
                .setIn(['currSelWeapon', 'currItemPoweredBy'], fromJS(poweredByCalc(currItem.DMG)))
                .setIn(['currSelWeapon', 'currItemOption', 'optionView'], '')
                // .setIn(['currSelWeapon', 'currItemOption', 'bodyUp'], 0)
                // .setIn(['currSelWeapon', 'currItemOption', 'powerUp'], 0)
                .setIn(['currSelArmmor', 'currItemOption', 'optionView'], '')
                .setIn(['currSelArmmor', 'currItemOption', 'bodyUp'], 0)
                .setIn(['currSelArmmor', 'currItemOption', 'powerUp'], 0)
                .setIn(['currSelArmmor', 'currItemOption', 'prefixUp'], -1)
                .setIn(['currSelAcCt', 'currItemOption', 'optionView'], '')
                .setIn(['currSelAcCt', 'currItemOption', 'powerUp'], 0)
                .setIn(['plusUpGrid'], fromJS(plusUpGrid))
                .setIn(['currSelArmmor', 'currItemDefensedBy'], fromJS(poweredByCalc(currItem.DFS)))
                .setIn(['itemLayerPopInfo', 'lstItemList'], fromJS(list))
                .setIn(['itemFilters', 'itemKind'], id)
                ;
  },
  // [CTRL_WEAPON_UP]: (state, action) => {
  [SET_ITEM_DETAIL_OPTION]: (state, action) => {
    const {currSel, gubun} = action.payload;
    console.log(gubun);
    return state.setIn([currSel, 'currItemOption', 'optionView'], gubun);
  },
  [SET_BODY_UP]: (state, action) => {
    const {currSel, cnt} = action.payload;

    return state.setIn([currSel, 'currItemOption', 'optionView'], '')
                .setIn([currSel, 'currItemOption', 'bodyUp'], cnt);
  },
  [SET_POWER_UP]: (state, action) => {
    const {currSel, cnt} = action.payload;
    
    return state.setIn([currSel, 'currItemOption', 'optionView'], '')
                .setIn([currSel, 'currItemOption', 'powerUp'], cnt);
  },
  [SET_PREFIX_UP]: (state, action) => {
    const {currSel, cnt} = action.payload;
    
    return state.setIn([currSel, 'currItemOption', 'optionView'], '')
                .setIn([currSel, 'currItemOption', 'prefixUp'], cnt);
  },
  [SET_LOCAL_HIST]: (state, action) => {
    // const {lstItemList} = action.payload;
    // console.log('lstItemList : ' + JSON.stringify(action.payload))
    let list = getLocalStorageList(RECENT_KEY);

    return state.setIn(['itemLayerPopInfo', 'lstItemList'], fromJS(list))
                .setIn(['itemLayerPopInfo', 'openYn'], 'Y');
  },
  [SET_LAYER_OPEN_YN]: (state, action) => {
    const openYn = action.payload;
    // console.log('lstItemList : ' + JSON.stringify(action.payload))
    // let list = getLocalStorageList(RECENT_KEY);

    return state.setIn(['itemLayerPopInfo', 'openYn'], openYn);
  }
}, initialState);

const getItemFiltering = (gubun, state, itemKind, curItemList, clyn, illegal, tier, itemDtlDv01, itemDtlDv02, itemDtlDv03, itemDtlDv04, itemDtlDv05) => {
  if(gubun === 'filterKind' || gubun === 'itemInq') {
    clyn = state.getIn(['itemFilters', 'clyn']).toJS();
    illegal = state.getIn(['itemFilters', 'illegal']).toJS();
    tier = state.getIn(['itemFilters', 'tier']).toJS();
    itemDtlDv01 = state.getIn(['itemFilters', 'itemDtlDv01']).toJS();
    itemDtlDv02 = state.getIn(['itemFilters', 'itemDtlDv02']).toJS();
    itemDtlDv03 = state.getIn(['itemFilters', 'itemDtlDv03']).toJS();
    itemDtlDv04 = state.getIn(['itemFilters', 'itemDtlDv04']).toJS();
    itemDtlDv05 = state.getIn(['itemFilters', 'itemDtlDv05']).toJS();
  }
  
  if(gubun === 'filterKind' || gubun === 'filterDtl') {
    curItemList = state.getIn(['itemList','list'+itemKind]).toJS();
  }

  const result = curItemList.filter((item) => {
    return (
      (clyn.length === 0 ? true : clyn.some((ele) => item.CLYN === ele)) && 
      (illegal.length === 0 || (itemKind === '03' || itemKind === '04' || itemKind === '05' || itemKind === '06') ? true : illegal.some((ele) => item.ILLEGAL === ele)) &&
      (tier.length === 0 || (itemKind === '05' || itemKind === '06') ? true : 
        tier.some((ele) => item.TIER === ele)) &&
      (
        item.CTYPE === '1' ? (
          (itemDtlDv01.length === 0 && item.STYPE1 === '1' ? 
          true : itemDtlDv01.some((ele) => item.ITEM_DTL_DV === ele)) ||
          (itemDtlDv02.length === 0  && item.STYPE1 === '2' ?
          true : itemDtlDv02.some((ele) => item.ITEM_DTL_DV === ele))
        ) : 
        item.CTYPE === '2' ? (
          //AND STYPE1 IN('1','2','3','4','5','6')
          (itemDtlDv03.length === 0 && (item.STYPE1 === '1' || item.STYPE1 === '2' || item.STYPE1 === '3' || item.STYPE1 === '4' || item.STYPE1 === '5' || item.STYPE1 === '6') ? 
          true : (item.STYPE1 === '1' || item.STYPE1 === '2' || item.STYPE1 === '3' || item.STYPE1 === '4' || item.STYPE1 === '5' || item.STYPE1 === '6') ? 
            itemDtlDv03.some((ele) => item.ITEM_DTL_DV === ele) : true
          )
        ) : 
        // AND CTYPE IN('6','7','8','9','10','11','12')
        item.CTYPE === '6' || item.CTYPE === '7' || item.CTYPE === '8' || item.CTYPE === '9' || 
        item.CTYPE === '10' || item.CTYPE === '11' || item.CTYPE === '12' ? (
          itemDtlDv04.length === 0 ? true : 
          itemDtlDv04.some((ele) => item.ITEM_DTL_DV === ele)
        ) :
        item.CTYPE === '3' || item.CTYPE === '4' || item.CTYPE === '5' ? (
          itemDtlDv05.length === 0 ? true : 
          itemDtlDv05.some((ele) => item.ITEM_DTL_DV === ele)
        ) : true
      )
    );
  });

  return result;
}

const poweredByCalc = (item_dmg) => {
  var up_classes = [1, 1.1, 1.3, 1.5, 2, 3, 4];
  var up_rate = [0,1,2,3,4,5,6,7,8,9,1,1,1,3,3,3,6,6,6,10];
  var up_list = [];
  var up_cls_list = [];
  var calc_num = Number(item_dmg);
  var result_num = Number(item_dmg);

  for(var i in up_classes) {
    up_cls_list = [];
    calc_num = Number(item_dmg);
    result_num = Number(item_dmg);
    for(var j in up_rate) {
      calc_num = (calc_num/100*up_rate[j]) + calc_num;
      result_num = Math.round(calc_num);
      up_cls_list.push(Math.floor(result_num*up_classes[i]));
    }

    up_list.push(up_cls_list)
  }

  return up_list;
};

const getItemKind = (items) => {
  let CTYPE = '0';
  let STYPE1 = '0';
  let id = '01';
  
  if(items.length > 0) {
    CTYPE = items[0].CTYPE;
    STYPE1 = items[0].STYPE1;
  }else{
    CTYPE = items.CTYPE;
    STYPE1 = items.STYPE1;
  }
  
  if(CTYPE === '1') {
    if(STYPE1 === '1') {
      id = '01'; //원거리무기
    }else{
      id = '02'; //근거리무기
    }
  }else if(CTYPE === '2') {
    if(STYPE1 === '7') { //방패
      id = '03';
    }else{ //방어구
      id = '04';
    }
  }else if(CTYPE === '3' || CTYPE === '4' || CTYPE === '5') {
    id = '06';
  }else {
    id = '05';
  }

  return id;
}

const calcPlusUpGrid = () => {
  var base_value1 = 1.111111111;
  var base_value2 = 1.666666666;
  var base_value3 = 2.50;
  var value1_ary = [];
  var value2_ary = [];
  var value3_ary = [];
  var result_obj = {};
  var str_rt = 0.5;
  for(var i=0; i<11; i++) {
    var value = str_rt+(i*0.1);
    value1_ary.push((base_value1 * value));
    value2_ary.push((base_value2 * value));
    value3_ary.push((base_value3 * value));
  }
  
  result_obj.value1 = value1_ary;
  result_obj.value2 = value2_ary;
  result_obj.value3 = value3_ary;
  
  var real_result_list =[]
  var result_list = [];
  var list = [];
  var list_sub = [];
  var calc_value = 0;
  var armorr_ary = [1, 2, 6];

  for(var a=0; a<3; a++) {
    result_list = [];
    calc_value = 0;
    for(var j=0; j<3; j++) {
      list = [];
      calc_value = 0;
      for(var jj=2; jj<11; jj++) {
        list_sub = [];
        calc_value = 0;
        for(var jjj=0; jjj<15; jjj++) {
          if(jjj>=0 && jjj<=4) {
            calc_value = calc_value + Number(eval("value"+(j+1)+"_ary[jj]"));
          }else if(jjj>=5 && jjj<=9) {
            calc_value = calc_value + Number(eval("value"+(j+1)+"_ary[jj]")*2);
          }else{
            calc_value = calc_value + Number(eval("value"+(j+1)+"_ary[jj]")*3);
          }
  
          list_sub.push((calc_value*armorr_ary[a]).toFixed(2));
        }
        list.push(list_sub);
      }
      result_list.push(list);
    }
    real_result_list.push(result_list);
  }

  return real_result_list;
}

// const items1 = EX_ITEM_LIST01;